module.exports = __webpack_public_path__ + "static/images/icon-welfare-new5.473a624.png";